import React from "react";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../../components/IconButton";
import {useTranslation} from "react-i18next";
import {useCustomizer} from "../../../contexts/CustomizerContext";

type DeleteUserInputProps = {
    unique_id: string;
    onDelete?: (unique_id: string) => void;
    spot_id: number;
}

const DeleteUserInputButton: React.FC<DeleteUserInputProps> = (
    {
        unique_id,
        onDelete,
        spot_id,
    }
) => {
    const { canvas, setUserInputs, activeTemplate, uuids } = useCustomizer()
    const { t } = useTranslation(['customizer'])
    const deleteUserInput = (uid: string) => {
        const obj = canvas.getObjects().find((obj) => {
            return (obj.data?.unique_id === uid)
        })

        if (obj) canvas.remove(obj)
        canvas.requestRenderAll()

        setUserInputs((prevUserInputs) => {
            prevUserInputs.delete(uid)
            return new Map(prevUserInputs)
        })

        if (onDelete) onDelete(uid)
    }

    const onClickHandler = () => {
        deleteUserInput(unique_id)
        activeTemplate?.spots.filter((s) => s.sync_id === spot_id).forEach((s) => {
            const uid = uuids.get(s.id)
            if (uid) deleteUserInput(uid)
        })
    }

    return (
        <IconButton
            icon={faTrashAlt}
            color={'black'}
            onClick={() => onClickHandler()}
            title={t('delete')}
        />
    )
}

export default DeleteUserInputButton
